{
  "add": "Hozzáad",
  "add-barn-first-description": "Első telep regisztráció.",
  "add-cycle": "Rotáció hozzáadása",
  "add-day-old-chick-first-description": "Első regisztráció a telepítésre. A kiszállítást is itt lehet regisztrálni.",
  "age": "Kor",
  "amount": "Mennyiség",
  "app": {
    "cycles": "Rotációk",
    "deliveries": "Szállítások",
    "reports": "Jelentésk",
    "settings": "Beállítások",
    "products": "Termékek",
    "farmer-insights": "Gazdasági betekintés",
    "advices": "Tanácsokat",
    "feed-advice": "Takarmányozási javaslat",
    "reference-value-sheet": "Referenciaérték-lap",
    "standard-reference-value-sheet": "Szabványos Referenciaérték-lap",
    "reference-scheme": "referencia rendszer",
    "management": "Menedzsment",
    "performance": "Teljesítmény",
    "within-cycle-performance": "Teljesítmény a cikluson belül"
  },
  "farmer-insights": {
    "kpiGroups": {
      "TechnicalPerformance": "Technical performance",
      "FinancialPerformance": "Financial performance",
      "ArrivalAndDeparture": "Arrival & departure",
      "FeedConsumption": "Feed consumption",
      "WellBeing": "Well-being",
      "RevenueAndCost": "Revenue & costs"
    },
    "description": "Valós idejű betekintés a gazdaság állapotába!",
    "locations": "Helyek",
    "location": "Elhelyezkedés",
    "cycles": "Ciklusok",
    "barns": "Istállók",
    "detail-level": "Részletességi szint",
    "display-type": "Megjelenítés",
    "kpis-name": "KPI-k",
    "table": "Táblázat",
    "chart": "Diagram",
    "kpi-selection": "KPI kiválasztás",
    "aggregation": {
      "Sum": "Cumulative",
      "Average": "Average",
      "Min": "Min",
      "Max": "Max"
    },
    "custom-footers": {
      "end-total": "Periódus befejezése",
      "same-period": "ugyanabban az időszakban (Nyáj:",
      "last-weeks": "elmúlt hetek",
      "customer-average-selected-period": "Ügyfél átlagos kiválasztott időszak (Nyáj:"
    },
    "no-data": {
      "title": "cím",
      "description": "leírás"
    },
    "no-benchmark": "Nincs elegendő adat a meghatározásához (legalább 15 állomány szükséges).",
    "benchmark-title": "<Tenant>",
    "benchmark-selected-period": "ugyanezt az időszakot",
    "benchmark-last-weeks": "elmúlt 10 hét",
    "norm": "norma",
    "benchmark-settings": "Teljesítmény mérési beállítások",
    "settings": {
      "header": "Szűrők",
      "title": "Teljesítmény mérési beállítások",
      "subtitle": "Itt állíthatja be, hogy melyik mérőszámmal szeretné összehasonlítani állományát, ha nem „részletes” módban van",
      "selected-period-label": "<Tenant> a kiválasztott időszak referenciaértékének megjelenítése",
      "last-weeks-label": "<Tenant> benchmark kijelző az elmúlt 10 hétben",
      "customer-average-selected-period-label": "Az ügyfél átlagának megjelenítése a kiválasztott időszakban",
      "none": "Egyik sem",
      "select-multiple-benchmark-label": "Több benchmarkot is kiválaszthat",
      "select-one-benchmark-label": "Csak egy referenciaértéket választhat",
      "non-detailed-view-label": "Nem részletes nézetek",
      "detailed-view-label": "Részletes nézetek"
    },
    "reset-filters": "szűrők visszaállítása",
    "to": "amíg",
    "maxPrintWarning": {
      "title": "Warning",
      "message": "You have selected more than the max number of KPI's you're able to print. Only the first number of KPI's able to print will be shown when printing. Current possible number of KPI's when printing:"
    },
    "kpis": {
      "DayOldChicks": "Napos csibe száma",
      "DayOldChicksPrice": "Napos csibe ára",
      "TotalDeparture": "Összes vágóra küldött",
      "DepartureWeight": "Szállítási súly",
      "SlaughterWeight": "Vágási súly",
      "Revenue": "Bevétel",
      "FeedBalance": "Takarmányfelhasználás",
      "FeedBalancePrice": "Elfogyasztott takarmány ára",
      "LossPercentage": "Veszteség %",
      "ReplacementPercentage": "Hígító szemes százaléka",
      "FeedConversion": "Takarmány hasznosulás",
      "FeedConversion1500": "Takarmány hasznosulás 1500",
      "AverageWeightInGram": "Átlagsúly",
      "WeightedAverageAgeInDays": "Súlyozott átlag életnap",
      "WeightedAverageGrowthPerDay": "Átlagos napi testtömeggyarapodás",
      "ProductionNumber": "Gyártási szám",
      "DayOldChicksPerSquareMeter": "Csibe/m²",
      "FeedUsageInKgPerSquareMeter": "Takarmány felhasználás/m²",
      "FeedConsumptionPricePer100Kg": "Takarmány felhasználási ár",
      "PaidAmountPerKg": "Bevétel/kg",
      "NettoRevenue": "Nettó bevétel",
      "NettoRevenuePerChick": "Nettó bevétel/napos",
      "NettoRevenuePerSquareMeterPerDay": "Nettó bevétel/m²/nap",
      "RejectionRate": "Úti apadó",
      "PricePerDayOldChick": "Ár/naposcsibe",
      "FeedBalanceMixProduct": "Elfogyasztott takarmány premix mennyisége",
      "FeedBalanceRawProduct": "Elfogyasztott takarmány alapanyagok",
      "DeliveredKgPerSquareMeter": "Kiszállítás kg / m²",
      "NettoRevenuePerSquareMeter": "Nettó bevétel/m²",
      "FeedConsumptionPerDeliveredKg": "Takarmányköltség szállított kg -onként",
      "DayOldChicksWeight": "Csibe súly",
      "WeightedHeelDermatitis": "Súlyozott csánk gyulladás",
      "WeightedFootpadLesionNonePercentage": "Súlyozott talpfekély 0",
      "WeightedFootpadLesionModeratePercentage": "Súlyozott talpfekély 1",
      "WeightedFootpadLesionSeverePercentage": "Súlyozott talpfekély 2",
      "TotalLoss": "Veszteség",
      "WeightedFootpadLesionScore": "Súlyozott talpfekély pontszám",
      "FeedBalanceRawPrice": "Elfogyasztott takarmány alapanyagok ára",
      "FeedBalanceMixPrice": "Elfogyasztott takarmány premixmennyiség ára",
      "PartialDeparture": "Ciklus közben vágóra küldött",
      "FullDeparture": "Ciklus végén vágóra küldött",
      "NettoProfitInclOtherCosts": "Nettó nyereség, beleértve az egyéb költségeket",
      "DayOldChicksPriceExclDiscounts": "Chick érkezési ár exkluzív kedvezmények",
      "RevenueExclDiscounts": "Bevétel exkluzív kedvezmények",
      "FeedBalancePriceExclDiscounts": "Takarmányfogyasztási ár exkluzív kedvezmények"
    },
    "data-view-types": {
      "PerLocation": "Helyenként",
      "PerCycle": "Rotációnként",
      "PerCycleBarn": "Rotációnként/istálló",
      "PerLocationBarn": "istállónként"
    },
    "customer-average-selected-period": "Ügyfél átlagos kiválasztott időszak",
    "show-more": "mutass többet",
    "show-less": "mutass kevesebbet"
  },
  "within-cycle-performance": {
    "advice_and_reference-value-sheet": "Etetési tanácsok és szokásos kártya",
    "kpi": "KPI",
    "kpis": {
      "IndoorTemperature": "Beltéri hőmérséklet",
      "IndoorHumidity": "Beltéri páratartalom",
      "MortalityPercentage": "Halálozás%",
      "FeedIntakePerChick": "Takarmányfelvétel (csibénként)",
      "WaterIntakePerChick": "Vízfelvétel (csibénként)",
      "WeightGainPerChick": "Súlygyarapodás (csibénként)",
      "WaterToFeedRatio": "Víz / takarmány arány",
      "FeedConversionRate": "Feed konverziós arány",
      "LitterQuality": "Alom minősége",
      "LitterQualityCaked": "Lecsaptak",
      "LitterQualityLoose": "Szabály",
      "LitterQualityWet": "Nedves",
      "BodyWeight": "Testsúly",
      "GrowthPrediction": "Növekedési előrejelzés",
      "IndoorOutdoorTemperature": "Beltéri / Külső hőmérséklet",
      "IndoorOutdoorHumidity": "Beltéri / Kültéri páratartalom",
      "OutdoorTemperature": "Külső hőmérséklet",
      "OutdoorHumidity": "Kültéri páratartalom"
    },
    "no-data": "Nincs elérhető adat."
  },
  "area": "Körzet",
  "arrival-date": "Érkezés dátuma",
  "avined": "Avined",
  "balance": {
    "add-manual-delivery": "Szállítás hozzáadása",
    "balance-row": "Egyenleg sor",
    "barn-distribution": {
      "available-in-this-cycle": "Rendelkezése áll ebben a rotációban",
      "change-flock-allocation": "Állomány eloszlásának változása",
      "currently": "Jelenleg:",
      "delivery-line-info": "Kiszállítási információs sor",
      "flock-allocation": "Állomány eloszlása",
      "kg-per-chick": "kg/nap naposcsibe",
      "of-which-remaining": "ebből fennmaradó",
      "total-should-be": "Az összes mennyiség összege legyen",
      "totally-delivered": "Teljes szállítás",
      "usage-in-kg": "Felhasználás (kg)",
      "usage-in-other-cycles": "A következő turnusban felhasználás",
      "usage-in-this-cycle": "Felhasználás ebben a rotációban",
      "total": "Teljes",
      "totalRaw": "Teljes nyers takarmány",
      "totalCompound": "Összes összetett takarmány"
    },
    "consumption": "Felhasználás (kg)",
    "delivery-date": "Kézbesítés dátuma",
    "empty-day-old-chick-description": "Először regisztrált érkezés. Ezt követően felvehető az engyenleg sor itt.",
    "empty-day-old-chick-title": "Nincs kiszállítás",
    "empty-description": "Kattintson a 'újrakalkulásás' hogy mutassa az egyenleget.",
    "empty-title": "Egyenleg sor nem található",
    "manual-add": "Kézi",
    "multiple-deliveries": "Többszörös szállítás",
    "price": "ár",
    "product": "Termék",
    "quantity": "Mennyiség (kg)",
    "recalculate": "Visszaállítás",
    "recalculate-warning": {
      "text": "Minden takarmány kiszállítás az adott rotációra újra be lesz töltve. Az új kiszállításoka hozzá lesznekd adva. A mennyiségek 0-ra lesznek állítva.",
      "title": "Biztos benne hogy át akarja ütemezni?"
    },
    "remainder": "Maradék (kg)",
    "remainder-greater-than-quantity": "A maradék nem lehet nagyobb mint a megrendelt mennyiség.",
    "remainder-less-than-zero": "A fennmaradó értéke nem lehet kevesebb mint 0",
    "remainder-less-than-quantity": "A fennmaradó érték nem lehet kevesebb mint a mennyiség",
    "remainder-greater-than-zero": "A fennmaradó érték nem lehet nagyobb mint 0",
    "remainder-other-than-zero": "A fennmaradó érték nem lehet más mint 0.",
    "remainder-NaN": "A maradék nem érvényes szám.",
    "pending-changes-warning": {
      "title": "Nem mentett változtatások",
      "message": "Az egyenlegében nem mentett változások vannak.",
      "confirmText": "Folytatás mentés nélkül",
      "cancelText": "Megszünteti"
    },
    "save-confirm": {
      "title": "Mentse az egyenleget",
      "text": "Az egyenleg még nincs véglegesítve. Mentéssel és véglegesítéssel megadhatja a mérlegnek a “végleges” státuszt. Ha az egyenleg még nem teljes, válassza a mentést. Ezzel mentheti az egyenleget “ideiglenes” státusszal.",
      "alert": "Az egyenleg véglegesítése azért fontos, mert a forduló csak akkor lesz teljes a jelentésekben."
    },
    "edit-confirm": {
      "title": "Egyenleg szerkesztése",
      "text": "Ha úgy dönt, hogy megváltoztatja az egyenleget, akkor az egyenleg állapota “véglegesről” “ideiglenesre” változik. Ezután elvégezheti a változtatásokat és újra véglegessé teheti az egyenleget.",
      "alert": "Az egyenleg újbóli véglegesítése a változások után fontos, mert az előzetes mérlegkör nem lesz teljesként megjelölve a jelentésekben."
    },
    "not-finalized": {
      "title": "Az egyenleg nincs véglegesítve",
      "message": "Az egyenleg még nincs véglegesítve. Mentéssel és véglegesítéssel azonnal véglegesítheti az egyenleget."
    },
    "save-and-finalize": "Mentés és véglegesítés",
    "save": "Mentse",
    "edit": "Egyenleg",
    "edit-balance": "Egyenleg szerkesztése",
    "delete-confirm": {
      "text": "szöveg",
      "title": "cím"
    },
    "has-empty-barns": {
      "title": "Hibás egyenlegsorok találhatók",
      "message": "Olyan mérlegsorokat találtunk, ahol nem volt beállítva istálló. Ezt a problémát az egyenleg újraszámítása oldja meg."
    },
    "barn-name": "Istálló",
    "invoice-date": "Számla kiállítási dátuma",
    "invoice-number": "Számlaszám",
    "delivery-number": "Szállítási azonosító"
  },
  "balance-item": {
    "add-product": "Adja hozzá kézzel",
    "error-product-selected": "Válasszon egy terméket",
    "no-products": "Nem található meglévő termék.",
    "product": "Termék"
  },
  "balance-item-delivery": {
    "amount": "Istállónkénti mennyiség",
    "current-usage": "Jelenlegi felhasználás",
    "error-amount": "Írja be az összeget",
    "error-no-amount": "Írja be az összeget legalább egy istállóra.",
    "remaining-of": "fennmaradó"
  },
  "balance-item-manual": {
    "amount": "Istállónkénti mennyiség",
    "delivery-date": "Kézbesítés dátuma",
    "error-amount": "Írja be az összeget",
    "error-delivery-date": "Adja meg a szállítási dátumot",
    "error-no-amount": "Írja be az összeget legalább egy istállóra.",
    "error-price": "Írja be a nettó árat",
    "error-product-title": "Adja meg a termékleírást",
    "error-supplier-name": "Írja be a beszállító nevét",
    "error-vat": "Adja meg az áfa-százalékát",
    "price": "Nettó ár",
    "product-title": "Termék leírás",
    "product-type-multiple": "Vegyes termék",
    "supplier-name": "Beszállító neve",
    "vat": "Áfa"
  },
  "balance-summary": {
    "consumption-per-delivered-chick": "Felhasználás/elszállított madár",
    "final-stock": "Végső készlet",
    "initial-stock": "Kezdeti készlet",
    "title": "Egyenleg összefoglaló",
    "total": "Teljes felhasználás",
    "delivery-stock": "szállítási készlet",
    "product": "termék"
  },
  "barn": "Istálló",
  "barn-item": {
    "area": "Alapterület",
    "error-name-duplicate": "Ez az istálló név már használatban van. Adjon meg egy egyedi istállónevet",
    "error-name-required": "Adja meg az istálló mevét",
    "error-surface-area": "Adja meg az alapterületet",
    "name": "Istálló leírása",
    "animal-group-barn-id": "Animal Group Istálló",
    "not-mapped": "(Nincs feltérképezve)"
  },
  "birth-date": "Kelés napja",
  "breed": "Fajta",
  "cadaver": "Hulla",
  "catching": "Szállítás",
  "certification": "Tanúsítvány",
  "chick-price": "Ár/napos",
  "chickens": "Csirkék",
  "chicks-parents-age-in-weeks": "Szülőpár kora",
  "chicks-weight-in-grams": "Napos tömeg",
  "close-round": "Lezárt rotáció",
  "concept": "Koncepció",
  "costs": "Költségek",
  "costs-specification": "Költség specifikáció",
  "couple": "Pár",
  "couple-number": "Szám",
  "couples": "Párok",
  "customer-id": "Ügyfél-azonosító",
  "cycle": "Rotáció",
  "cycle-navigation": {
    "balance": "Egyenleg",
    "closure": "Lezárás",
    "day-old-chick": "Telepítés",
    "departure": "Szállítás",
    "general": "Általános"
  },
  "cycle-number": "Száma",
  "enter-amounts": "Adja meg az összegeket",
  "n/a": "n/a",
  "cycle-overview": {
    "barn": "Istálló",
    "consumption-empty": {
      "description": "Adjon hozzá készletet, hogy itt lássa az egyenleg sorokat.",
      "title": "Nincsenek egyeneleg sorok."
    },
    "daily-performance-empty": {
      "description": "A heti / napi megfigyelések elérhetővé tételéhez adja hozzá a készletet.",
      "title": "A bejegyzés nem érhető el."
    },
    "cycle": "Rotáció",
    "delete-cycle": "Töröl",
    "edit-current-week": "Heti regisztrációk rögzítése",
    "weekregistration-overview": "Heti regisztrációk áttekintése",
    "detailedOverview": "Részletes",
    "edit": "Hozzáad",
    "edit-cycle": "Hozzáad",
    "option-all-barn": "- az összes istálló -",
    "panel": {
      "add-day-old-chick": "hozzáad Ellátott",
      "add-departure": "Szállítás hozzáadása",
      "amount": "Mennyiség",
      "balance-overview": "Egyenleg áttekintő",
      "balance-title": "Takarmány felhasználás",
      "birthdate": "Kelés napja",
      "consumption": "Felhasználás (kg)",
      "consumption-per-chick": "Felhasználás/csirke (g)",
      "date": "Ellátási dátum",
      "day-old-chick-overview": "Ellátási áttekintés",
      "day-old-chick-title": "Ellátott csibék",
      "day-old-chick-total": "Összes ellátott csibe",
      "departure-overview": "Szállítási áttekintés",
      "departure-title": "Szállítás",
      "departure-total": "Teljes szállítás",
      "departuredate": "Szállítási dátum",
      "departureweight": "Induló súly",
      "price": "Ár",
      "price-ex-vat-per-chick": "Ár áfával együtt per csirke",
      "price-ex-vat": "Ár áfával együtt",
      "product-title": "Takarmány megnezvezése",
      "product-type-mixedproduct": "Takarmány",
      "product-type-rawproduct": "Alapanyag",
      "revenue": "Bevétel",
      "slaughterweight": "Vágási súly",
      "type": "Típus",
      "type-full": "Teljes leürítés",
      "type-manual": "Utasítás",
      "type-partial": "Leszedés",
      "type-platform": "Platform",
      "type-start": "Platform",
      "total-consumption": "Teljes felhasználás",
      "daily-performance-title": "Heti és napi megfigyelési regisztráció",
      "edit-current-week": "Heti regisztrációk rögzítése",
      "cycle-title": "Rotáció",
      "discount-title": "Kedvezmények",
      "discount-overview": "Kedvezmények áttekintése"
    },
    "placeholder": "- válasszon -",
    "start-new-cycle": "Új rotáció kezdése",
    "weekregistration-download": "Sablon letöltése",
    "weekregistration-upload": "Importálás",
    "weekregistration-select-file": "Válaszd ki a fájlt...",
    "weekregistration-upload-csv-title": "Válassza ki az importálni kívánt CSV-fájlt",
    "upload-csv-message": "Az oszlopokat nem szabad eltávolítani a sablonból, még akkor sem, ha üresek. A mezők üresen hagyhatók.",
    "upload-csv-notification": "Válassza ki az importálni kívánt CSV-fájlt",
    "weekregistration-select-interval-type": "Intervallum típusa",
    "download-weekly-report": "Heti jelentés",
    "cycle-start-in-future-warning-description": "Ennek a ciklusnak a kezdő dátuma a jövőben van. Emiatt nem lehet megfigyeléseket regisztrálni.",
    "cycle-start-in-future-warning-title": "A ciklus még nem indult el"
  },
  "wdo-labels": {
    "mortality": "Halálozási ráta",
    "feedIntake": "Takarmányfelvétel",
    "waterIntake": "Víz fogyasztás",
    "indoorTemperature": "Beltéri hőmérséklet",
    "outdoorTemperature": "Kültéri hőmérséklet",
    "indoorHumidity": "Beltéri páratartalom",
    "outdoorHumidity": "Kültéri páratartalom",
    "weight": "Súly",
    "litterQuality": "Alom minősége",
    "litterQualities": {
      "Loose": "Alom minősége Laza",
      "Caked": "Alom minősége Sütve",
      "Wet": "Alom minősége Nedves"
    },
    "selection": "kiválasztás",
    "selectionSmall": "kicsi a választék",
    "selectionLegProblems": "kiválasztási lábproblémák",
    "feedIntakeGramPerBird": "Takarmányfelvétel (gramm/madár)",
    "feedIntakeKg": "Takarmányfelvétel (kg)",
    "waterIntakeMililiterPerBird": "Vízfelvétel (milliliter madáronként)",
    "waterIntakeL": "Vízfelvétel (L)",
    "kilogramSuffix": "Kg",
    "gramSuffix": "Gramm",
    "literSuffix": "L",
    "mililiterSuffix": "Ml",
    "ageInDays": "Életkor napokban"
  },
  "wdo-settings": {
    "title": "Heti és napi megfigyelések, beállítások",
    "disabled-message": "Ezek a beállítások nem módosíthatók, mivel a héten adatok kerültek beírásra.",
    "startday-description": "A kezdő nap az állományok érkezési dátumával összefüggésben",
    "startday-label": "Hétköznapi beállítások",
    "startday-placeholder": "- jelölje ki a kezdő napot -",
    "weekly-daily-description": "Itt tudja meghatározhatja, hogy milyen információkat szeretne megadni naponta vagy hetente.",
    "open-settings": "Nyissa meg a beállításokat",
    "general-option": {
      "label": "Általános beállítások",
      "per-day": "Naponta minden",
      "per-week": "Hetenete minden"
    },
    "setting-option": {
      "off": "Ki",
      "per-day": "Naponta",
      "per-week": "Hetente"
    },
    "delete-confirm": {
      "title": "cím",
      "text": "szöveg"
    }
  },
  "wdo-registration": {
    "all-settings-are-off-title": "Minden regisztrációs mező ki van kapcsolva.",
    "all-settings-are-off-message": "Először lépjen a Heti és Napi megfigyelési beállításokhoz ebben a ciklusban az Általános menüpontnál, és ott állítsa be a beállításokat.",
    "registration": "Heti és napi megfigyelések regisztrációi",
    "cycle-date": "Érkezés dátuma",
    "cycle-end-date": "Ciklus végének dátuma",
    "select-week": "Hét",
    "select-week-placeholder": "- válasszon ki egy hetet -",
    "select-barn": "Istálló",
    "select-barn-placeholder": "- válasszon egy istállót -",
    "validation-errors": {
      "total-must-be-100": "The total of the litter quality combined should be 100%.",
      "date-is-not-valid-title": "Hibás dátumok a feltöltési fájlban",
      "date-is-not-valid-description": "A feltöltési fájlban olyan nap/hét szerepel, amely nagyobb/kisebb, mint a ciklus záró/kezdő dátuma. A megfelelő dátumú adatok mentésre kerülnek."
    },
    "next-day": "Következő nap"
  },
  "wdo-registration-overview": {
    "title": "Megfigyelési regisztrációk áttekintése",
    "weekly-registrations": "Heti megfigyelési regisztrációk",
    "daily-registrations": "Napi megfigyelési regisztrációk",
    "columns": {
      "weeknr": "Hét",
      "date": "Dátum"
    },
    "no-observations-found": {
      "title": "Nem található észrevétel",
      "message": "Ehhez a ciklushoz nem adtak heti vagy napi megfigyelést."
    }
  },
  "chicks": "csajok",
  "cycles": "Rotáció",
  "dashboard": "Irányítópult",
  "date": "Dátum",
  "date-of-arrival": "Érkezés dátuma",
  "day-old-chicks": "Napos Csirke",
  "days": "napok",
  "decontamination": "Fertőtlenítés",
  "delete": "Törölni",
  "delete-item-balance": "Törölni szeretné az egyenleg sort?",
  "delete-item-barn-item": "Törölni szeretné az istállót?",
  "delete-item-day-old-chick": "Törölni szeretné a napos csirkét?",
  "delete-item-departure": "Törölni szeretné az szállítást?",
  "delete-item-flock-cycle": "Törölni szeretné a rotációt?",
  "delivery": {
    "deliveries": "Szállítások",
    "delivery": "Szállítás"
  },
  "delivery-item": {
    "amount": "Istállónkénti mennyiség",
    "delivery-date": "Szállítás dátuma",
    "error-amount": "Adja hozzá a mennyiséget",
    "error-delivery-date": "Adja hozzá a szállítás dátumát",
    "error-no-amount": "Adjon hozzá legalább egy istállónyi mennyiséget.",
    "error-price": "Adja hozzá a nettó árat",
    "error-product-title": "Adja meg a termékleírást",
    "error-supplier-name": "Adja meg a szolgáltató nevét",
    "error-units-delivered": "Adja meg a leszállított egységeket",
    "error-units-delivered-not-enough": "A szállítás egy részét már felhasználták a ciklusmérlegekben. Ezért legalább a következőkre van szüksége:",
    "error-vat": "Adja meg az áfa százalékát",
    "external-product-id": "Termék hivatkozási száma",
    "manual-delivery": "Kézi kézbesítés",
    "price": "Nettó ár (áfa nélkül)",
    "product-title": "Termék leírás",
    "product-type-multiple": "Vegyes termék",
    "supplier-name": "Szállító neve",
    "units-delivered": "Leszállított egységek",
    "vat": "Áfa",
    "price-per-100kg": "Nettó ár 100 kg-ra (áfa nélkül)",
    "error-price-per-100kg": "Adja meg a nettó 100 kg-os árat",
    "barn": "Istálló",
    "invoice-date": "Számla kiállítási dátuma",
    "invoice-number": "Számlaszám",
    "vat-percentage": "ÁFA százalék"
  },
  "delivery-overview": {
    "active": "Aktív",
    "delivery": "Szállítás",
    "delivery-lines": "Szállítási sorok",
    "display-in-cycle": "Rotáció kijelzése",
    "no-deactivation": {
      "description": "Létezik egy rotáció, amelyben ezt a szállítást használják.",
      "title": "Hatástalanítás nem lehetséges"
    },
    "no-deliveries": {
      "description": "A szállítások automatikusan hozzáadódnak, és itt jelennek meg.",
      "title": "Nincsenek szállítások"
    },
    "remaining-of": "fennmaradó",
    "remove-delivery-warning": {
      "text": "Ezzel eltávolítja a kiszállítást a listájáról. Az egyenlegekben szereplő kiszállítások nem távolíthatók el.",
      "title": "Biztosan el akarja távolítani ezt a kiszállítást?"
    },
    "table": {
      "deliveryDate": "Kézbesítési dátum",
      "deliveryId": "Szállítási azonosító",
      "product": "Termék",
      "isActive": "Aktív",
      "showInFinalSetup": "Megjelenítés a Végső beállításban",
      "invoiceDate": "Számla kiállítási dátuma",
      "invoiceNumber": "Számlaszám"
    }
  },
  "departure": {
    "barn": "Istálló",
    "empty-day-old-chicks-description": "Adja meg a szállítást és itt fog megjelenni.",
    "empty-day-old-chicks-title": "Nincs szállítás",
    "empty-description": "Adja meg a szállítást és itt fog megjelenni.",
    "empty-title": "Nincs szállítás"
  },
  "departure-date": "Szállítás időpontja",
  "departure-item": {
    "age": "Kor",
    "amount-of-chicks": "Mennyiség",
    "average-weight": "Áltlagsúly",
    "barn": "istálló",
    "chicks": "csirkék",
    "date": "Dátum",
    "error-amount-of-chicks-max": "A csirkék maximális száma:",
    "error-amount-of-chicks-min": "Adjon hozzá legalább egy madarat",
    "error-amount-of-chicks-required": "Adja meg a csirkék számát",
    "error-barn": "Jelölje ki az istállót",
    "error-date": "Adja meg az indulás dátumát. Ennek a legkorábbi érkezési dátum után kell lennie, de nem a jövőben.",
    "error-no-chicks-remaining": "nem maradtak csibék az szállításra",
    "error-type": "Adja meg az szállítás típusát",
    "footpad-lesion-score": "Talpfekély pontozás értéke",
    "footpad-lesion-none": "Pontszám 0",
    "footpad-lesion-moderate": "Pontszám 1",
    "footpad-lesion-severe": "Pontszám 2",
    "footpad-lesion-validation": "A 0, 1 és 2 pontszám ban lévő százalékok legfeljebb 100%-ot",
    "heel-dermatitis": "Csánkgyulladás értéke",
    "revenue": "Teljes bevétel (áfa nélkül)",
    "slaughter-results": "Vágási eredmények",
    "slaughter-weight": "Teljes vágási súly",
    "rejection-at-slaughterhouse": "Elutasítás a vágóhíd",
    "rejection-during-transport": "Elutasítás során közlekedési",
    "slaughterhouse": "Vágóhíd",
    "type": "Tipús",
    "type-full": "Teljes leürítés",
    "type-partial": "leszedés",
    "weight": "szállítási súly",
    "weight-validation": "A teljes vágási tömeg nem lehet nagyobb, mint az indulási súly.",
    "diverseCosts": "Változatos költségek",
    "revenueSubTotal": "Bevétel"
  },
  "departure-title": "Szállítás",
  "departure-type-full": "Összes",
  "departure-type-partial": "Részleges",
  "download-pdf": "töltse le pdf-ben",
  "edit": "Szerkesztés",
  "electricity": "elektromosság",
  "error-amount-of-chickens": "Adja meg a csibék mennyiségét",
  "error-amount-of-chicks": "Adja meg a naposcsibék mennyiségét",
  "error-amount-of-chicks-too-big": "A napos csibék száma túl sok",
  "error-arrival-date": "Adja meg a telepítés dátumát",
  "error-barn-selected": "Jelölje ki az istállót",
  "error-breed": "Jelölje ki a fajtát",
  "error-chick-birth-date": "Adja meg a kelés dátumát",
  "error-chick-price": "Adja meg a napos csibe egységárát",
  "error-concept": "Adja meg a nevelési feltételeket",
  "error-cycle-number": "Adja meg a rotáció különleges jelölését",
  "error-hatchery": "Keltető kijelölése",
  "error-start-date": "Adja meg a kezdés dátumát",
  "error-surface-area": "Adja meg az istálló területét",
  "error-total-costs": "Adja meg az összes költséget",
  "error-total-price": "Adja meg a mennyiséget",
  "feed": "Takarmány",
  "flocks": "Nyáj",
  "general": "Általános",
  "grams": "gramm",
  "hatchery": "Keltető",
  "healthcare": "Egészségügy",
  "heating": "Fűtés tipusa",
  "litter": "Alom",
  "management": "Menedzsment",
  "manure": "Ürülékkel szennyezett alom",
  "no-barns-description": "Adjon hozzá egy istállót, és itt fog megjelenni.",
  "no-barns-title": "Nincsenek istállók",
  "no-cycle-selected-description": "Jelöljön ki egy kört az adatai megtekintéséhez.",
  "no-cycle-selected-title": "Nincs kijelölve ciklus",
  "no-cycles-description": "Adja meg a rotációt ls itt fog megjelenni.",
  "no-cycles-title": "Nincsenek rotációk",
  "no-day-old-chicks-description": "Adja meg a szállítást és itt fog megjelenni.",
  "no-day-old-chicks-title": "Nincsenek szállítások",
  "no-departures-description": "Adja meg az szállítást és itt fog megjelenni.",
  "no-departures-title": "Nincsenek izállítások",
  "none": "Egyik sem",
  "nr": "Szám",
  "number-of-day-old-chicks": "Mennyiség",
  "other": "Más",
  "print": "Nyomtatása",
  "remove-cycle": "Rotáció eltávolítása",
  "report-navigation": {
    "barn-report": "Istálló áttekintése"
  },
  "report-overview": {
    "barn": "istálló",
    "barn-report": "Istálló áttekintése",
    "barn-report-loading": "generálása folyamatban van ...",
    "cycle": "Rotáció",
    "reports": "Jelentések",
    "cycle-closed": "(A ciklus befejeződött)"
  },
  "save-as-concept": "Mentés mint koncepció",
  "settings": "Beállítások",
  "settings-navigation": {
    "barns": "Istállók",
    "observationsetting": "Megfigyelések",
    "rvssetting": "Referencia-értéklapok",
    "farmresultsetting": "FarmResult",
    "performance": "Teljesítmény",
    "finalsetupsetting": "Végső beállítás",
    "discountsetting": "Kedvezmények",
    "sustainabilitysetting": "Fenntarthatóság"
  },
  "observations-setting": {
    "description": "Szeretné nyomon követni a ciklus teljesítményét heti és napi rendszerességgel?",
    "switch": "Aktiválja a heti/napi megfigyeléseket"
  },
  "column-setting": {
    "title": "Oszlop beállítások",
    "description": "Oszlopok"
  },
  "rvs-setting": {
    "title": "Referencia-értéklapok beállítások",
    "temperatureInside-option": {
      "label": "Hőfok",
      "Celcius": "Celcius",
      "Fahrenheit": "Fahrenheit",
      "short": {
        "Celcius": "(°C)",
        "Fahrenheit": "(F)"
      }
    },
    "feedIntake-option": {
      "label": "Feed",
      "Gram": "Gramm",
      "Kilogram": "Kilogramm",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "waterIntake-option": {
      "label": "Víz",
      "ML": "Milliliter",
      "DL": "Deciliter",
      "L": "Liter",
      "short": {
        "ML": "(ml)",
        "DL": "(dl)",
        "L": "(l)"
      }
    },
    "weight-option": {
      "label": "Súly",
      "Gram": "Gramm",
      "Kilogram": "Kilogramm",
      "short": {
        "Gram": "(g)",
        "Kilogram": "(kg)"
      }
    },
    "dayoffset": {
      "title": "Kezdő nap beállítása",
      "label": "kezdő nap"
    }
  },
  "specify-costs": "Bővített költségek",
  "start-date": "Szállítás dátuma",
  "title": "PoultryNEXT",
  "title_Agrifirm": "PoultryNEXT",
  "title_Agravis": "Avidata broiler",
  "total-costs": "Összes költség",
  "total-price": "Összes Ár/napos",
  "unspecified-costs": "Nem meghatározott költségek",
  "water": "Víz",
  "water-additives": "Vízhez adható anyagok",
  "weeks": "hetek",
  "search": "Keresés",
  "dateFrom": "Tól től",
  "dateTo": "Amíg",
  "days-of-week": {
    "Monday": "hétfő",
    "Tuesday": "kedd",
    "Wednesday": "szerda",
    "Thursday": "csütörtök",
    "Friday": "péntek",
    "Saturday": "szombat",
    "Sunday": "vasárnap"
  },
  "unitOfMeasure": {
    "g/day": "g/nap",
    "€/m²/day": "€/m²/nap",
    "$/m²/day": "$/m²/nap",
    "£/m²/day": "£/m²/nap",
    "zł/m²/day": "zł/m²/nap",
    "Ft/m²/day": "Ft/m²/nap"
  },
  "feed-advice": {
    "overview": {
      "title": "Takarmányozási szaktanács áttekintése",
      "empty": {
        "title": "Takarmányozási szaktanács nem elérhető",
        "description": "Takarmányozási szaktnács ebben a pillanat nem áll rendelkezésre"
      },
      "table-header": {
        "name": "Név",
        "created": "Létrehozva",
        "updated": "Frissítve",
        "updatedAdvisorName": "Frissítette",
        "isActive": "Aktív"
      },
      "buttons": {
        "add": "Takarmányozási szaktanács létrehozása",
        "edit": "Szerkesztés",
        "delete": "Törlés"
      }
    },
    "create-from-reference": {
      "title": "Takarmányozási javaslat létrehozása",
      "scratch-title": "Elölről kezd ",
      "scratch-option-title": "Kezdj el egy takarmányozási javaslat",
      "scratch-button": "Elölről kezd ",
      "scratch-option-subtitle": "Ez egy üres takarmányozási javaslat",
      "reference-schemes-title": "Válassz egy Ajánlott takarmányozási javaslat mint alap",
      "reference-schemes-button": "Kezdeni valamivel ",
      "product": "Termék",
      "products": "Termékek",
      "additive": "Adalékanyag",
      "additives": "Adalékok"
    },
    "dialog": {
      "deleteConfirm": "Biztos benne, hogy törli az takarmányozási javaslatot?",
      "deleteConfirmWhenInUse": "Ez a hírcsatorna-tanács egy ciklushoz kapcsolódik. Biztosan törli ezt a hírcsatorna-tanácsot?"
    },
    "create": {
      "print": "Nyomtatás",
      "title": "Takarmánytanács",
      "name": "Takarmánytanács neve",
      "error-name": "A takarmánytanács megnevezése kötelező.",
      "description": "Leírás",
      "description-placeholder": "Takarmánytanács leírása",
      "product-placeholder": "- válasszon egy terméket -",
      "add-product": "Termék hozzáadása",
      "table-header": {
        "productName": "Termék",
        "chickenWeightInGrams": "Csaj súlya (g)",
        "ageFrom": "Kor (days)",
        "ageTo": "Életkor (days)",
        "totalFeed": "Takarmányfelvétel (g)",
        "coreFeed": "Core (g)",
        "wheatFeed": "Búza (g)",
        "comment": "Hozzászólások",
        "age": "Kor (nap)",
        "coreFeedTons": "Mag (tonna)",
        "wheatFeedTons": "Búza (tonna)",
        "dosage": "adagolás (kg/tonna)",
        "applicationMoment": "életkor alkalmazása"
      },
      "created": "Létrehozva",
      "updated": "Frissítve",
      "number-of-day-old-chicks": "Nappali fiókák száma",
      "validation-error": {
        "title": "Érvényesítési hibák",
        "feedadvice-name": "A hírcsatorna-tanács neve kötelező",
        "age-from": "Kortól kezdve kötelező",
        "chicken-weight": "A csirke súlya kötelező",
        "product": "A termék kötelező",
        "total-feed": "Teljes takarmány szükséges",
        "age-to": "Életkor szükséges (kivéve az utolsó sort)",
        "age-min-max": "Az Életkortól alacsonyabbnak kell lennie, mint az Életkortól."
      },
      "products": "alapvető takarmányozási tanácsok",
      "additives": "kiegészítéseket",
      "show-additives": "kiegészítések megjelenítése",
      "add-additive": "add hozzá"
    },
    "print": {
      "farmcompany": "Vállalat",
      "customernr": "Ügyfélszám",
      "contactperson": "Kapcsolattartó",
      "location": "Elhelyezkedés",
      "customerservice": "Vevőszolgálat",
      "table-header": {
        "productName": "Termék",
        "chickenWeightInGrams": "Csaj súlya",
        "age": "Kor",
        "totalFeed": "Takarmányfelvétel",
        "coreFeed": "Core",
        "wheatFeed": "Búza",
        "comment": "Hozzászólások",
        "gramPerChick": "g/csaj",
        "orderQuantity": "Vásárlás Mennyiség (tonna)",
        "units_gram": "(g)",
        "units_days": "(nap)",
        "dosage": "Adagolás",
        "units_kgton": "kg/tonna",
        "applicationMoment": "Alkalmazási pillanat"
      }
    }
  },
  "standard-reference-value-sheet": {
    "overview": {
      "title": "Szabványos Referencia-értéklapok áttekintése"
    },
    "create": {
      "title": "Szabványos Referenciaérték-lap"
    }
  },
  "reference-value-sheet": {
    "overview": {
      "title": "Referencia-értéklapok áttekintése",
      "empty": {
        "title": "A referenciaérték adatai nem állnak rendelkezésre",
        "description": "Jelenleg nem állnak rendelkezésre referenciaérték-adatok."
      },
      "table-header": {
        "name": "Név",
        "created": "Létrehozva",
        "updated": "Frissítve",
        "updatedAdvisorName": "Frissítette",
        "isActive": "Aktív"
      },
      "buttons": {
        "add": "Referenciaérték-lap hozzáadása",
        "edit": "Szerkesztés",
        "delete": "Törlés",
        "copy-as-new": "Másolás újként",
        "copy-to-other-country": "Másolás másik országba"
      },
      "country": "Ország"
    },
    "dialog": {
      "deleteConfirm": "Biztosan törölni kívánja ezt a Referencia-értéklapot?",
      "deleteConfirmWhenInUse": "Ez a referenciaérték-lap egy ciklushoz van kapcsolva. Biztosan törli ezt a referenciaérték-lapot?"
    },
    "create-from-standard": {
      "title": "Referenciaérték-lap létrehozása",
      "scratch-title": "Elölről kezd",
      "scratch-option-title": "Indítson el egy referenciaértéket",
      "scratch-button": "Elölről kezd",
      "scratch-option-subtitle": "Ez egy üres referenciaérték lap",
      "reference-value-sheet-title": "Válasszon alapként referenciaértéket",
      "reference-value-sheet-button": "Kezdeni valamivel "
    },
    "create": {
      "print": "Nyomtatás",
      "title": "Referenciaérték-lap",
      "name": "Referenciaérték-lap neve",
      "error-name": "Referenciaérték A lap neve kötelező",
      "add-one-day-values-row": "Nap hozzáadása",
      "number-of-days": "Napok",
      "add-multiple-day-values-rows": "Napok hozzáadása",
      "description": "Leírás",
      "description-placeholder": "Referenciaérték lap leírása",
      "no-day-values-title": "A Referencia-értéklap üres",
      "no-day-values-description": "A kezdéshez adjon napokat az alábbi Referenciaérték-laphoz.",
      "table-header": {
        "day": "Nap",
        "temperatureInside": "Hőmérséklet belül ",
        "relativeHumidity": "Relatív páratartalom (%)",
        "feedIntake": "Takarmánybevitel ",
        "feedIntakePerChickPerDay": "Takarmánybevitel ",
        "feedIntakeTotal": "Takarmányfelvétel összesen ",
        "feedIntakePerChickTotal": "Takarmányfelvétel összesen ",
        "waterIntake": "Víz ",
        "weight": "Súly ",
        "mortality": "Halálozás (%)",
        "feedConversion": "Feedkonverzió",
        "waterToFeedRatio": "Viz:Takarmánybevitel"
      },
      "created": "Létrehozva",
      "updated": "Frissítve",
      "validation-error": {
        "title": "Érvényesítési hibák",
        "refvalsheet-name": "A referenciaértéklap neve kötelező"
      }
    },
    "print": {
      "farmcompany": "Vállalat",
      "customernr": "Ügyfélszám",
      "contactperson": "Kapcsolattartó",
      "location": "Elhelyezkedés"
    },
    "select-country": {
      "title": "Válassza ki az országot",
      "description": "Válassza ki az országot, ahová másolni szeretné",
      "label": "Ország"
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Ajánlott takarmányozási javaslat áttekintés",
      "empty": {
        "title": "Ajánlott takarmányozási javaslat tételek nem elérhetőek",
        "description": "Jelenleg nem érhetőek el az ajánlott takarmányozási javaslat tételek."
      },
      "table-header": {
        "name": "Neve",
        "created": "Létrehozva",
        "updated": "Frissítve",
        "updatedAdvisorName": "Frissítve",
        "isActive": "Aktív"
      },
      "buttons": {
        "add": "Ajánlott takarmányozási javaslat létrehozása",
        "edit": "Szerkesztés",
        "delete": "Törlés"
      },
      "country": "Ország"
    },
    "dialog": {
      "deleteConfirm": "Biztos benne, hogy törli az ajánlott takarmányozási javaslatot?"
    },
    "create": {
      "title": "Ajánlott takarmányozási javaslat",
      "name": "Ajánlott takarmányozási javaslat neve",
      "error-name": "Az ajánlott takarmányozási javaslat neve szükséges.",
      "description": "Megnevezés",
      "description-placeholder": "Ajánlott takarmányozási javaslat megnevezése",
      "product-placeholder": "- termék kiválasztás -",
      "add-product": "Termék hozzáadás",
      "table-header": {
        "productName": "Termék",
        "chickenWeightInGrams": "Csibe súlya (g)",
        "ageFrom": "Kor (days)",
        "ageTo": "Életkor (days)",
        "totalFeed": "Takarmányfelvétel (g)",
        "coreFeed": "szemes takarmány (g)",
        "wheatFeed": "Búza (g)",
        "comment": "Hozzászólások"
      },
      "created": "Létrehozva",
      "updated": "Frissítve"
    }
  },
  "product-title": "Termékek",
  "product-save": "Termék mentése",
  "product-saved": "A termék mentve!",
  "product-overview": {
    "title": "Termék áttekintés",
    "overview": {
      "productName": "Név",
      "productCode": "Termékkód",
      "phase": "Fázisok",
      "isActive": "Aktív",
      "productType-Feed": "Takarmány",
      "productType-Additive": "Adalékanyag",
      "productType": "Terméktípus"
    },
    "no-products": {
      "title": "Nem található termék",
      "description": "A Hozzáadás gombra kattintva létrehozható egy termék."
    },
    "delete-confirmation-title": "Termék törlése",
    "delete-confirmation-message": "Biztosan eltávolítja ezt a terméket?",
    "delete-error-message": "Nem sikerült eltávolítani a terméket. Győződjön meg arról, hogy a terméket nem referenciasémában használják.",
    "delete-error-in-use-message": "Nem tudtuk eltávolítani a terméket, mert egy vagy több takarmánytanácsban van használatban.",
    "country": "Ország",
    "delete-confirmation-message-when-in-use": "Ezt a terméket egy vagy több takarmánytanácsban használják. Biztosan eltávolítja ezt a terméket?"
  },
  "create-product": {
    "title-create": "Új termék",
    "title-edit": "Termék szerkesztése:",
    "product-name": "Termék Név",
    "phases-label": "Fázisok",
    "product-code": "Termékkód",
    "error-product-name": "Kérjük, írja be a termék nevét.",
    "error-product-code": "Kérjük, töltse ki a termék termékkódját.",
    "error-code-name-already-in-use": "Kérjük, használjon egyedi név és kód kombinációt.",
    "product-type": {
      "label": "Terméktípus",
      "Feed": "Takarmány",
      "Additive": "Adalékanyag"
    },
    "error-product-type": "A termék típusa kötelező."
  },
  "countries": {
    "BE": "Belgium",
    "DE": "Németország",
    "HU": "Magyarország",
    "NL": "Hollandia",
    "PL": "Lengyelország",
    "JO": "Jordánia",
    "NG": "Nigéria",
    "JM": "Jamaica",
    "TZ": "Tanzánia",
    "DA": "Németország-Agravis"
  },
  "save": "Mentés",
  "report-title": "Istálló áttekintése baromfi",
  "report-name": "Nyáj-jelentés-",
  "report-headers": {
    "general": "Általános",
    "day-old-chicks": "Napos csirke",
    "total": "Teljes",
    "departures": "Indulás",
    "balance": "Egynelet",
    "key-figures": "Kulcs adatok",
    "technical": "Technikai",
    "financial": "Pénzügyi"
  },
  "report-columns": {
    "customer": "Vevő",
    "location": "Telephely",
    "barn": "Istálló",
    "breed": "Fajta",
    "concept": "koncepció",
    "start-date": "Induló dátum",
    "date": "Dátum",
    "age": "Átlagos életkor [nap]",
    "amount": "Mennyiség",
    "price": "Ár (Áfa bélkül)",
    "discount": "Kedvezmény (áfa nélkül)",
    "delivered": "Leszállított [kg]",
    "weight": "Testtömeg [g]",
    "paid": "Fizetett [kg]",
    "rejected": "Selejt [%]",
    "feed-code": "Takarmány kódja",
    "feed-name": "Gyártási szám",
    "consumption": "Felhasználás [kg]",
    "consumption-per-day-old-chick": "Felhasználás naposcsibénként [g]",
    "day-old-chicks": "Napos csirke/m²",
    "drop-out-total": "Teljes elhullás (%)",
    "avg-age": "Átlagos életkor (nap)",
    "avg-weight": "Álagsúly (g)",
    "deliveredkg-per-m2": "Leszállított kg/m²",
    "growth": "Testtömeg növekedés (g/nap)",
    "feed-conversion": "Takarmány hasznosulás",
    "feed-conversion-1500": "Takarmány hasznosulás 1500",
    "replacement": "Pótlás (%)",
    "avg-rejected": "Átlagos selejt (%)",
    "production-number": "Takarmány neve",
    "price-per-delivered-chick": "Leszállított ár csirkénk (ct)",
    "feed-price-per-100": "Takarmány ár/100 kg takarmány",
    "feed-price-per-delivered-kg": "A takarmány ára szállított kg -onként (ct)",
    "yield-per-kg": "Átlagos húskihozatal/fizetett kg",
    "feed-profit": "Teljes takarmány nyereség",
    "feed-profit-per-day-old-chick": "Takarmány nyereség/ napos csibe (ct)",
    "feed-profit-per-m2-per-day": "Takarmánygyarapodás/m²/nap (ct)",
    "cycle-nr": "Rotáció száma",
    "barns": "Pajták",
    "netto-profit-incl-other-costs": "Nettó nyereség, beleértve az egyéb költségeket",
    "discountLabel-ledenvoordeel": "Tagsági előny",
    "discountLabel-ledenkorting": "Tagi kedvezmény",
    "discountLabel-integratiepremie": "Integrációs prémium",
    "discountLabel-nieuwbouwpremie": "Új építési prémium",
    "discountLabel-ncw": "Nettó jelenérték eloszlás",
    "total-incl-discount": "Összesen (beleértve a kedvezményeket)",
    "discountLabel-korting": "Kedvezmény",
    "discountLabel-overig": "Egyéb",
    "discountLabel-nabetaling": "Vissza fizetés",
    "discountLabel-correctievoerprijs": "Helyesbítés feedprice",
    "discountLabel-vergoedingvolgensafspraak": "Megállapodás szerinti kompenzáció",
    "feed-profit-per-m2": "Takarmány nyereség/m²"
  },
  "total": "teljes",
  "days-short": "napok",
  "parent-stock-identifier": "Szülői részvény azonosítója",
  "import": "Importálás",
  "csv-import": {
    "delivery-success": "A szállítások sikeresen importálva.",
    "departure-success": "Az elszállítások sikeresen importálva.",
    "errors": {
      "amount-exceeds-remaining": "${rowNumber}. sor: A mennyiség meghaladja a(z) '${barn}' istállóban megmaradt csibék számát. A maximálisan megengedett mennyiség ${maxAmount}.",
      "barn-not-found": "${rowNumber}. sor: A(z) '${value}' istálló nem található a kiválasztott ciklusban.",
      "configured-slaughterhouses-could-not-be-loaded": "A beállított vágóhidakat nem sikerült betölteni.",
      "cycle-could-not-be-loaded": "A(z) '${cycleId}' ciklust nem sikerült betölteni.",
      "cycle-invalid": "A CSV-ben szereplő elszállítások érvénytelenek a kiválasztott ciklushoz.",
      "cycle-not-found": "A(z) '${cycleId}' ciklus nem található az aktuális ügyfélhez/helyszínhez.",
      "date-before-first-arrival": "${rowNumber}. sor: A dátumnak az első érkezési dátumra vagy azutánra kell esnie.",
      "date-in-future": "${rowNumber}. sor: A dátum nem lehet jövőbeli.",
      "duplicate-column": "A CSV duplikált '${column}' oszlopot tartalmaz.",
      "file-empty": "A CSV-fájl üres.",
      "file-required": "CSV-fájl megadása kötelező.",
      "file-too-large": "A CSV-fájl túl nagy. A maximálisan megengedett méret ${maxSizeKb} KB.",
      "invalid-date": "${rowNumber}. sor: A(z) ${field} kötelező, és érvényes dátumnak kell lennie.",
      "invalid-number": "${rowNumber}. sor: A(z) ${field} mezőnek érvényes számnak kell lennie.",
      "missing-required-columns": "A CSV-ből hiányoznak a kötelező oszlopok: ${columns}.",
      "no-data-rows": "A CSV-nek legalább egy adatsort kell tartalmaznia.",
      "required-field": "${rowNumber}. sor: A(z) ${field} mező kötelező.",
      "required-positive-whole-number": "${rowNumber}. sor: A(z) ${field} kötelező, és pozitív egész számnak kell lennie.",
      "required-valid-number": "${rowNumber}. sor: A(z) ${field} kötelező, és érvényes számnak kell lennie.",
      "skip-import-invalid": "${rowNumber}. sor: Az importálás kihagyása mezőnek üresnek kell lennie, vagy az alábbi értékek egyikét kell tartalmaznia: yes, no, true, false, 1, 0, x.",
      "slaughterhouse-not-found": "${rowNumber}. sor: A(z) '${value}' vágóhíd nem található.",
      "too-many-rows": "A CSV túl sok sort tartalmaz. A maximálisan megengedett sorok száma ${maxRows}.",
      "total-slaughterweight-higher-than-departure-weight": "${rowNumber}. sor: A teljes vágási súly nem lehet nagyobb az elszállítási súlynál.",
      "type-invalid": "${rowNumber}. sor: A típus kötelező, és Teljes vagy Részleges értékűnek kell lennie.",
      "unterminated-quote": "A CSV olyan értéket tartalmaz, amelyben a nyitó idézőjelhez nem tartozik záró idézőjel.",
      "unknown": "A CSV importálása sikertelen.",
      "unsupported-file-type": "Csak CSV-fájlok támogatottak."
    },
    "download-template": "Sablon letöltése",
    "invalid-file": "Válasszon érvényes CSV-fájlt.",
    "upload": "CSV feltöltése"
  },
  "slaughter-report": "Vágási jelentés",
  "link-slaughter-results-title": "Link vágási eredmények",
  "link-slaughter-results-description": "Vágási jegyzőkönyvenként válasszon istállót. Minden vágási jelentéshez egy indulási sor kerül létrehozásra.",
  "slaughter-date": "Vágás dátuma",
  "number-of-chickens": "A csirkék száma",
  "departure-weight-kg": "Indulási súly (kg)",
  "show-financial-data": "Pénzügyi adatok megjelenítése",
  "financial-results": "Pénzügyi eredmény",
  "link-to-barn": "Link az istállóhoz",
  "imported-slaughter-report-label": "Importált vágási jelentés",
  "slaughter-weight-kg": "Vágási súly (kg)",
  "veterinary": "Állatgyógyászati",
  "employment": "Munkaerő",
  "otherRevenue": "Egyéb bevételek",
  "otherCosts": "Egyéb költségek",
  "discount-title": "Kedvezmények",
  "discount-label": "Akciós címke",
  "discount-applicabilityType": "Vonatkozik",
  "discount-amount": "Összeg, nem tartalmazza áfa",
  "discount-item": {
    "applicabilityType-arrivalcost": "Érkezési költségek",
    "applicabilityType-feedcost": "Takarmányköltségek",
    "applicabilityType-departurerevenue": "Indulási bevétel",
    "add-discount": "Kedvezmény hozzáadása",
    "labelType-ledenvoordeel": "Tagsági előny",
    "labelType-ledenkorting": "Tagi kedvezmény",
    "labelType-integratiepremie": "Integrációs prémium",
    "labelType-nieuwbouwpremie": "Új építési prémium",
    "labelType-ncw": "Nettó jelenérték eloszlás",
    "labelType-korting": "Kedvezmény",
    "labelType-overig": "Egyéb",
    "labelType-nabetaling": "Vissza fizetés",
    "labelType-correctievoerprijs": "Helyesbítés feedprice",
    "labelType-vergoedingvolgensafspraak": "Megállapodás szerinti kompenzáció"
  },
  "discount": {
    "no-discounts-title": "Még nincs kedvezmény.",
    "no-discounts-description": "Adjon hozzá egy kedvezményt, és itt megjelenik."
  },
  "delete-item-discount": "El szeretné távolítani a kedvezményt?",
  "farm-result": {
    "table-header": {
      "sensorActuator": "Érzékelő/Működtető Id",
      "barn": "Istálló",
      "sensorActuatorName": "Érzékelő/működtető neve",
      "farmResultLocationId": "Hely Id"
    },
    "select-barn-placeholder": "- válassz egy istállót -"
  },
  "discountLabel-korting": "Kedvezmény",
  "discountLabel-overig": "Egyéb",
  "discountLabel-nabetaling": "Vissza fizetés",
  "discountLabel-correctievoerprijs": "Helyesbítés feedprice",
  "discountLabel-vergoedingvolgensafspraak": "Megállapodás szerinti kompenzáció",
  "delete-item-day-old-chick-used-in-balance": "Ez a szállítás jelenleg használatban van az egyenlegen. Ha a szállítás törlését választja, akkor az egyenleget újra kell számolni. Törölni szeretné a szállítmányt?",
  "edit-day-old-chick_barn-used-in-balance": "Ön egy pajtát cserél, amelyet a mérlegen használnak. Ha elmenti ezt a módosítást, akkor az egyenleget újra kell számolni. Akarod folytatni?",
  "cycle-description": "Leírás",
  "confirm": "Beküldés",
  "interval-type-Day": "Nap",
  "interval-type-Week": "Hét",
  "unitOfMeasure-setting": {
    "title": "Mértékegység",
    "warning": "A mértékegység beállításainak módosítása a matematikai kerekítés miatt kis értékkülönbségeket eredményezhet.",
    "waterIntakeUnit": "Vízbevezető egység",
    "CumulativeLiter": "Összesített liter",
    "MililiterPerBird": "Mililiter madáronként",
    "feedIntakeUnit": "Takarmányfelvételi egység",
    "CumulativeKilogram": "Összesített kilogramm",
    "GramPerBird": "Gram per madár"
  },
  "error-amount-of-chicks-minimum": "A csibék minimális mennyisége:",
  "animal-group": {
    "animalGroupTitle": "Animal Group",
    "switchDay": "Váltás napja",
    "addSwitchDay": "Add Switch Day",
    "phaseFrom": "Fázis Kezdő",
    "phaseTo": "Fázis Ide",
    "date": "Dátum",
    "medication": "Gyógyszer",
    "treatmentDateStart": "A kezelés megkezdése",
    "treatmentDateEnd": "A kezelés vége",
    "addMedication": "Gyógyszer hozzáadása",
    "diagnose": "Diagnózis",
    "quantity": "Mennyiség",
    "unit": "Egység",
    "quantityUnitDescriptions": {
      "kilogram": "Kilogramm",
      "gramsPerLitre": "Gramm literenként",
      "percentage": "Százalék",
      "gram": "Gramm",
      "noUnit": "Nincs mértékegység",
      "gramsPerKilogram": "Gramm kilogrammonként",
      "milligram": "Milligramm",
      "milligramsPerKilogram": "Milligramm kilogrammonként"
    },
    "vaccination": "Oltás",
    "addVaccination": "Adja hozzá az oltást",
    "vaccine": "Vakcina",
    "poultryDisease": "Baromfi betegség",
    "vaccinationMethod": "Vakcinázási módszer",
    "validationDialogTitle": "Szükséges információ",
    "validationDialogMessage": "Kérjük, adja meg a szükséges adatokat a táblázatokban",
    "veterinarianTitle": "Állatorvos"
  },
  "final-setup-setting": {
    "switch": "Végső beállítás",
    "chick-delivery-switch": "Csibék szállítása",
    "feed-delivery-switch": "Takarmányszállítások",
    "departure-switch": "Szállítás",
    "discount-switch": "Kedvezmények",
    "title": "Végső beállítás",
    "default-settings-title": "Alapbeállítások",
    "masterdata": {
      "title": "Törzsadatok",
      "notes": "Megjegyzések",
      "payer": "Fizető",
      "payer-email": "Fizető e-mail",
      "representative-agrifirm": "<Tenant> képviselője",
      "separate-stable": "Külön istálló",
      "integration-premium": "Integrációs prémium",
      "discount-value": "kedvezmény értéke",
      "agrifirm-member": "<Tenant> tagja"
    }
  },
  "invoice-date": "Számla kiállítási dátuma",
  "invoice-number": "Számlaszám",
  "vat-percentage": "ÁFA százalék",
  "vat": "Áfa (%)",
  "amount-including-vat": "Áfát tartalmazó összeg (€)",
  "final-setup": {
    "chick-deliveries": "Csibe szállítások",
    "empty-chick-deliveries-title": "Nincs csibe szállítás",
    "empty-chick-deliveries-description": "Nincs csibe szállítás",
    "day-old-chick": "Egynapos csibe",
    "feed-deliveries": "Takarmányszállítások",
    "empty-feed-deliveries-title": "Nincs takarmány kiszállítás",
    "empty-feed-deliveries-description": "Nincs takarmány kiszállítás",
    "empty-departures-description": "Nincsenek indulások",
    "departures": "Indulás",
    "empty-departures-title": "Nincsenek indulások",
    "discounts": "Kedvezmények",
    "empty-discounts-title": "Nincs kedvezmény",
    "empty-discounts-description": "Nincs kedvezmény",
    "print-footer": "Minden általunk kötött megállapodásra és termékünkre és/vagy szolgáltatásunkra kizárólag az Agrifirm Általános Szállítási Feltételei vonatkoznak. Ezeket első kérésre ingyenesen elküldjük Önnek, valamint megtekinthető és elmenthető az alábbi címen is: https://www .agrifirm.nl/globalassets/agrifirm-group/agrifirm-nl/leveringsvoorwaarden/general-terms--nl.pdf​",
    "print-footer-agravis": "Minden általunk kötött megállapodásra és termékünkre és/vagy szolgáltatásunkra kizárólag az Agravis Általános Szállítási Feltételei vonatkoznak. Ezeket első kérésre ingyenesen elküldjük Önnek.",
    "print-description": "Leírás",
    "print-message-line-1": "Tisztelt Hölgyem / Uram,",
    "print-message-line-2": "Az elmúlt kör számláiról áttekintést küldünk.",
    "print-end-line-1": "A fenti áttekintésnek meg kell felelnie az Ön adminisztrációjának.",
    "print-end-line-2": "Üdvözlettel,",
    "print-company-name": "Agrifirm NWE BV",
    "print-company-name-agravis": "Agravis",
    "print-company-email": "Email: kengetallenadministratie@agrifirm.com",
    "print-company-email-agravis": "Email: info@agravis.nl",
    "print-company-phone": "Telefon: 088 - 488 2976",
    "print-company-phone-agravis": "",
    "print-to-receive": "Ön fogadásával",
    "print-total-feed": "Összes takarmány, lásd a mellékletet a specifikációért",
    "print-invoice-number": "Nincs számla.",
    "print-amount-excluding-vat": "Áfa nélküli összeg",
    "print-vat-amount": "Áfa összeg",
    "print-amount-including-vat": "Áfát tartalmazó összeg",
    "print-product": "Termék",
    "print-net-weight": "Nettó kg",
    "include-in-calculations-label": "Vegye figyelembe a számításokban",
    "print-to-pay": "Hogy fizessen",
    "print-payment-terms": "Kérjük, hogy a fenti összeget 14 napon belül fizesse be ügyfélszámának megadásával az NL.86.RABO.010.10.50.003 bankszámlára.",
    "print-subtotal": "Részösszeg",
    "feed-delivery-end-date": "A végső beállítási ciklus befejezési dátuma",
    "additional-invoices": "További számlák",
    "empty-additional-invoices-title": "Nincsenek további számlák",
    "empty-additional-invoices-description": "Nincsenek további számlák",
    "additional-invoices-add": "Számla hozzáadása",
    "additional-invoices-delete-confirm-title": "Távolítsa el a kiegészítő számlát",
    "additional-invoices-delete-confirm-description": "Biztosan eltávolítja ezt a számlát?",
    "fixed-price": "fix árú megállapodás",
    "fixed-price-per-100": "Ár 100 kg-ra",
    "fixed-price-correction": "Árkorrekció megegyezés szerint",
    "price-agreement": "ár megállapodás",
    "per-100-kg": "/ 100 kg ÁFA nélkül."
  },
  "amount-excluding-vat": "Összes Ár/napos (€)",
  "discount-description": "Leírás",
  "discount-showInFinalSetup": "Megjelenítés a Végső beállításban",
  "label": "Címke",
  "link-slaughter-invoices-description": "Válassza ki a ciklushoz kapcsolandó számlákat. Minden számlához egy sor jön létre a végső beállításban.",
  "link-slaughter-invoices-title": "Link vágási számlák",
  "slaughter-invoice": "Vágási számla",
  "vaccination-price": "Az oltás ára csibénként",
  "discount-price": "Az oltás ára csibénként",
  "diverse-price": "Változatos költség egy csibére",
  "total-price-including-vat": "Összeg, beleértve áfa",
  "total-calculated-amount": "Teljes összeg",
  "total-calculated-amount-including-vat": "Teljes összeg áfával",
  "arrival-notification-cycle-overview": "Az oltásonkénti nettó ár és a különféle tételek csibénkénti részét a pénzügyi áttekintés tartalmazza, ahol a végösszeg megtalálható",
  "arrival-notification-final-setup": "Az oltásonkénti nettó ár és a különféle tételek csibénkénti részét a pénzügyi áttekintés tartalmazza, ahol a végösszeg megtalálható",
  "edit-day-old-chick": "Szerkesztés Telepítés",
  "edit-departure": "Szerkesztés Szállítás",
  "of-delivery": "a Telepítés",
  "delivery-date": "Szállítás dátuma",
  "delivery-number": "Szállítási azonosító",
  "base-quantity": "Mennyiség (kg)",
  "discount-setting": {
    "title": "Kedvezmények",
    "memberDiscountNL": "Tagi kedvezmény (€)",
    "memberBenefitNL": "Tagsági juttatás (%)",
    "memberBenefitAbroad": "Tagsági juttatás külföldön (%)",
    "warning-title": "Óvakodik!",
    "warning-message": "Ezeket az értékeket minden ügyfél és hely esetében alkalmazzák. Ne változtassa meg őket."
  },
  "sustainability": {
    "calculations": {
      "source": "Forrás",
      "value": "Érték",
      "unit": "Mértékegység",
      "description": "Tekintse meg a korábbi számításokat, vagy számoljon ki egy másik ciklust.",
      "new": "Új számítás",
      "result": "Mentett eredmény",
      "history": "Korábbi számítások",
      "last-updated": "Utoljára frissítve",
      "history-description": "Válasszon egy számítást az eredmény megtekintéséhez.",
      "calculation": "Számítás",
      "view-result": "Eredmény megtekintése",
      "empty": "Ehhez a ciklushoz még nincs mentett számítás.",
      "select-cycle": "Válasszon ciklust a mentett számítások megtekintéséhez.",
      "loading": "Számítások betöltése…",
      "load-error": "A számításokat nem sikerült betölteni. Próbálja újra.",
      "retry": "Újrapróbálkozás",
      "pending": "Ez a számítás még feldolgozás alatt áll. Frissítse az eredményt később.",
      "calculating": "Takarmány importálása és a karbonlábnyom kiszámítása…",
      "result-failed": "Ez a számítás sikertelen. Ellenőrizze a követelményeket a számítási panelen, majd próbálja újra. Ha a hiba fennáll, forduljon tanácsadójához.",
      "attempt-failed": "Az utolsó próbálkozás sikertelen. Ellenőrizze az alábbi követelményeket, majd próbálja újra. A mentett eredmények továbbra is elérhetők.",
      "status": {
        "complete": "Kiszámítva",
        "pending": "Feldolgozás alatt",
        "failed": "Sikertelen"
      }
    },
    "readiness": {
      "view-details": "Takarmányadatok megtekintése",
      "requirements-met": "követelmény teljesítve",
      "title": "Követelmények",
      "checking": "A szükséges adatok ellenőrzése…",
      "error": "A szükséges adatok ellenőrzése sikertelen. Próbálja újra.",
      "ready": "A szükséges adatok teljesek.",
      "blocked": "A számítás előtt pótolja az alábbi adatokat.",
      "complete": "Teljes",
      "action-required": "Teendő szükséges",
      "edit-arrivals": "Betelepítések szerkesztése",
      "edit-departures": "Kiszállítások szerkesztése",
      "edit-resources": "Éves energiaadatok szerkesztése",
      "edit-bedding": "Alomadatok szerkesztése",
      "advisor": "Az adatok javításához forduljon tanácsadójához. Adja meg a fenti termék- és szállítási adatokat.",
      "disclaimer": "Az ellenőrzés a szükséges adatokra vonatkozik. A Sustell továbbra is elutasíthatja a számítást.",
      "recheck": "Újraellenőrzés",
      "calculation-failed": "A Sustell nem tudta kiszámítani ezt a karbonlábnyomot. Ellenőrizze az alábbi feltételeket, majd próbálja újra. Ha a hiba fennáll, forduljon tanácsadójához.",
      "requirements": {
        "cycle": "Betelepítések, kiszállítások és érvényes dátumok",
        "farm-resources": "Energiaadatok minden szükséges évre",
        "bedding": "Alomadatok",
        "feeds": "A takarmány tápértékei és kibocsátásai"
      },
      "arrival-weight": "Átlagos betelepítési tömeg madaranként",
      "departure-weight": "Átlagos kiszállítási tömeg madaranként",
      "issues": {
        "feeds-missing": "Rögzítse a keveréktakarmány-fogyasztást ennek a ciklusnak a takarmánymérlegében.",
        "arrivals-missing": "Rögzítse a csibék betelepítését.",
        "departures-missing": "Rögzítse a kiszállításokat.",
        "cycle-dates-invalid": "Javítsa a ciklus, a betelepítések és a kiszállítások dátumait.",
        "arrival-data-invalid": "Adjon meg pozitív madárszámot és betelepítési tömeget grammban madaranként.",
        "departure-data-invalid": "Adjon meg pozitív madárszámot és teljes kiszállítási tömeget kg-ban.",
        "departure-weight-below-arrival": "Az átlagos kiszállítási tömegnek legalább az átlagos betelepítési tömeggel kell megegyeznie. Ellenőrizze a betelepítési tömeget grammban madaranként, a teljes kiszállítási tömeget kg-ban és a madárszámokat.",
        "farm-resources-missing": "Rögzítse az energiafogyasztást erre az évre",
        "cycle-dates-required": "Rögzítsen érvényes betelepítéseket és kiszállításokat a szükséges évek ellenőrzéséhez.",
        "bedding-type-missing": "Válasszon alomtípust.",
        "bedding-amount-missing": "Adja meg az alom mennyiségét.",
        "ship-to-missing": "A szállítási hely nincs összekapcsolva a takarmányszállítóval.",
        "delivery-missing": "A szállítási adatok nem érhetők el.",
        "delivery-line-missing": "A szállított termék adatai nem érhetők el.",
        "feed-data-invalid": "A szükséges takarmányadatok hiányoznak vagy érvénytelenek.",
        "feed-settings-missing": "A takarmányimport beállításai hiányosak.",
        "farm-resources-not-calculated": "Mentse újra az energiaadatokat a fogyasztás ehhez a ciklushoz rendeléséhez."
      },
      "fields": {
        "Consumption": "Takarmányfogyasztás (kg), nullánál nagyobb",
        "Co2Total": "Teljes karbonlábnyom",
        "Co2TotalMismatch": "A teljes CO₂-érték nem egyezik a biogén, fosszilis és földhasználat-változásból eredő kibocsátások összegével. Kérje tanácsadóját a takarmányadatok javítására.",
        "Biogenic": "Biogén kibocsátások",
        "FossilExcludingPeatEmissions": "Fosszilis kibocsátások tőzeg nélkül",
        "FossilPeatEmissions": "Tőzegkibocsátások",
        "LandUseChange": "Földhasználat-változásból eredő kibocsátások",
        "DryMatterAmount": "Szárazanyag-tartalom",
        "RoughProtein": "Fehérjetartalom",
        "ProductIdentifier": "Termékazonosító"
      },
      "edit-feeds": "Takarmánymérleg szerkesztése",
      "edit-cycle": "Ciklus szerkesztése"
    },
    "sustainability": "Fenntarthatóság",
    "farm-resources": "Energia évente",
    "carbon-footprint": "Szén-lábnyom",
    "add-farm-resources": "Adjon hozzá mezőgazdasági erőforrásokat",
    "confirm-delete-farm-resource": "Törli a mezőgazdasági erőforrást?",
    "farm-resource-deleted": "Farm erőforrás törölve",
    "farm-resource-saved": "Mezőgazdasági erőforrás mentve",
    "year": "Év",
    "farm-settings-saved": "A farm beállításai mentve",
    "farm-settings-enable-co2-calculation": "CO2-számítások engedélyezése ehhez a gazdasághoz",
    "resource": {
      "electricity": "Villamos energia (kWh)",
      "electricity-photovoltaic": "Villany nap (kWh)",
      "electricity-wind": "Szélvillany (kWh)",
      "natural-gas": "Földgáz (m³)",
      "diesel": "Dízel (L)",
      "gasoline": "Benzin (L)",
      "coal": "Szén (KG)",
      "propane-lpg": "Propán / LPG (L)",
      "water": "Víz (m³)",
      "cycle-start-date": "Kezdő dátum",
      "cycle-end-date": "Befejezési dátum",
      "status": "Állapot",
      "statuses": {
        "complete": "Teljes",
        "partial": "Részleges"
      },
      "water-error": "A víznek pozitív számnak kell lennie",
      "electricity-error": "Az elektromosságnak pozitív számnak kell lennie",
      "electricity-photovoltaic-error": "Az elektromosságnak, a Napnak pozitív számnak kell lennie.",
      "electricity-wind-error": "A szélenergia esetében a számnak pozitívnak kell lennie.",
      "natural-gas-error": "A földgáznak pozitív számnak kell lennie",
      "diesel-error": "A dízelnek pozitív számnak kell lennie",
      "gasoline-error": "A benzinnek pozitív számnak kell lennie.",
      "propane-lpg-error": "A propán/LPG értékének pozitív számnak kell lennie.",
      "coal-error": "A szénnek pozitív számnak kell lennie"
    },
    "farm-resources-title": "Éves energiafogyasztás",
    "cycle-resources": "Energiafogyasztás ciklusonként",
    "value": "Élősúly értéke (kg CO2eq / kg testsúly)",
    "notification-title": "Fontos információk a CO2-számításokról",
    "notification-description": "A karbonlábnyom kiszámítása a Sustell LCA szoftver segítségével történik. Az alapot a jelenlegi Nevedi előírások szerinti takarmányhoz kapcsolódó CO2-számítások képezik. A helyes számítás elvégzéséhez minden adatot teljes körűen meg kell adni, például a <b>teljes állomány műszaki eredményeit, beleértve a termelést, az elszállítást/vágást és az energiafogyasztást.</b>\nA megjelenített értékek változhatnak az éghajlattudomány fejlődése és az ebből következő számítási módszerek, valamint a jogszabályok és vonatkozó szabványok módosulása miatt. Bár az itt bemutatott információkat gondosan állítottuk össze, jogi igény ezekből nem származtatható.",
    "action-text-close": "Elrejt",
    "action-text-open": "Megmutat",
    "farm-resources-not-complete": "A ciklus erőforrásai nem teljesek.",
    "bedding-type-required": "Az ágynemű típusa szükséges a ciklushoz.",
    "bedding-amount-required": "A ciklushoz szükséges ágynemű mennyisége.",
    "start-calculation": "Kezdje el a CO2 kiszámítását",
    "refresh-carbon-footprint": "CO2-lábnyom frissítése",
    "carbon-footprint-title-error": "Szénlábnyom számítási hiba",
    "carbon-footprint-title": "Karbonlábnyom számítás",
    "carbon-footprint-text": "Elkezdődik a szénlábnyom-számítás. Kérjük, legyen türelmes, amíg a folyamat befejeződik (kb. 1 perc).",
    "carbon-footprint-refresh-error-title": "A szénlábnyom frissítése nem sikerült",
    "carbon-footprint-refresh-error-text": "Nem sikerült frissíteni a szénlábnyomot. Kérjük, próbálja újra néhány pillanat múlva."
  },
  "bedding-type": "Ágynemű típusa",
  "bedding-types": {
    "NoBedding": "Nincs ágynemű",
    "BarleyStraw": "Árpaszalma",
    "MaizeStover": "Kukorica tűzhely",
    "OatStraw": "Zabszalma",
    "SawDust": "Fűrészpor",
    "SunflowerHusk": "Napraforgóhéj",
    "WheatStraw": "Búzaszalma",
    "Woodshavings": "Faforgács"
  },
  "bedding-amount": "Ágynemű mennyisége",
  "bedding-amount-error": "Az ágynemű mennyiségének pozitív számnak kell lennie",
  "transport-distance": "Szállítás keltetőből",
  "transport-distance-error": "A nevelőlétesítményből történő szállításnak 0 és 1000 közötti számnak kell lennie.",
  "time-in-free-range": "Szabadtartásban töltött idő",
  "time-in-free-range-error": "A szabadtartásban töltött időnek 0 és 100 közötti számnak kell lennie.",
  "general-settings-error": "Hiba történt a PoultryNEXT beállításainak lekérésekor.",
  "tenants": {
    "Agrifirm": "agrifirmálja",
    "Agravis": "agravis"
  }
}
